<template>
  <div v-if="isLoggedIn" class="nav-wrapper">
    <b-navbar shadow wrapper-class="container is-max-hd">
      <template #brand>
        <b-navbar-item tag="router-link" :to="{ path: '/' }">
          <img style="margin-bottom: -6px" src="/static/logo-wide.png" />
        </b-navbar-item>
      </template>
      <template #start>
        <b-navbar-item class="nav-item desktop-nav-item">
          <router-link
            :to="{ name: 'InquiryList' }"
            class="nav-link"
            :class="{ 'is-active': isInquiriesActive }"
          >
            <b-icon icon="magnify" class="mr-2"></b-icon>
            Inquiries
          </router-link>
        </b-navbar-item>
        <b-navbar-item class="nav-item desktop-nav-item">
          <router-link
            :to="{ name: 'BlanketVOBList' }"
            class="nav-link"
            :class="{ 'is-active': isBlanketVOBActive }"
          >
            <b-icon icon="card-account-details" class="mr-2"></b-icon>
            Blanket VOB Search
          </router-link>
        </b-navbar-item>
        <b-navbar-item class="nav-item desktop-nav-item">
          <router-link
            :to="{ name: 'Reimbursement' }"
            class="nav-link"
            :class="{ 'is-active': isReimbursementActive }"
          >
            <b-icon icon="chart-bar" class="mr-2"></b-icon>
            Reimbursement
          </router-link>
        </b-navbar-item>
        <b-navbar-item class="nav-item desktop-nav-item">
          <router-link
            :to="{ name: 'PatientVerificationList' }"
            class="nav-link"
            :class="{ 'is-active': isPatientVerificationActive }"
          >
            <b-icon icon="account-check" class="mr-2"></b-icon>
            Patient Verifier
          </router-link>
        </b-navbar-item>
      </template>

      <template #end>
        <b-navbar-dropdown v-if="isLoggedIn" right :label="user.email">
          <div v-if="isAdmin">
            <b-navbar-item tag="router-link" :to="{ name: 'AdminIndex' }">
              <strong>Admin</strong>
            </b-navbar-item>
            <hr />
          </div>
          <div v-if="isManager">
            <b-navbar-item tag="router-link" :to="{ name: 'OrganizationDetail' }">
              Organization Settings
            </b-navbar-item>
            <b-navbar-item tag="router-link" :to="{ name: 'APIAccessKeys' }">
              API Keys
            </b-navbar-item>
            <b-navbar-item tag="router-link" :to="{ name: 'Reporting' }">Reporting</b-navbar-item>
            <b-navbar-item tag="router-link" :to="{ name: 'Alerting' }">Alerting</b-navbar-item>
          </div>
          <b-navbar-item v-if="permBatchInquiry" tag="router-link" :to="{ name: 'BatchInquiryList' }">
            Batch Reports
          </b-navbar-item>
          <b-navbar-item tag="router-link" :to="{ name: 'PayerOutageList' }">
            Payer Outage
          </b-navbar-item>
          <b-navbar-item tag="router-link" :to="{ name: 'ProfileDetail' }">
            Profile Settings
          </b-navbar-item>
          <b-navbar-item tag="a" href="mailto:support@quickadmit.com">Email Support</b-navbar-item>
          <b-navbar-item tag="router-link" :to="{ name: 'TermsAndConditions' }">
            Terms
          </b-navbar-item>
          <hr />
          <b-navbar-item @click="logout">Logout</b-navbar-item>
        </b-navbar-dropdown>
        <div class="buttons" v-if="!isLoggedIn">
          <b-navbar-item tag="div">
            <b-button type="is-primary" tag="router-link" :to="{ name: 'Login' }">Login</b-button>
            <b-button type="is-secondary" tag="router-link" :to="{ name: 'Register' }">
              Register
            </b-button>
          </b-navbar-item>
          <b-navbar-item tag="router-link" :to="{ name: 'Alerting' }">
            Alerts
          </b-navbar-item>
        </div>
      </template>
    </b-navbar>

    <!-- Mobile Navigation Tabs -->
    <div class="mobile-nav-tabs">
      <router-link
        :to="{ name: 'InquiryList' }"
        class="mobile-nav-tab"
        :class="{ 'is-active': isInquiriesActive }"
        aria-label="Inquiries"
      >
        <b-icon icon="magnify"></b-icon>
        <span class="mobile-nav-label">Inquiries</span>
      </router-link>

      <router-link
        :to="{ name: 'BlanketVOBList' }"
        class="mobile-nav-tab"
        :class="{ 'is-active': isBlanketVOBActive }"
        aria-label="Blanket VOB Search"
      >
        <b-icon icon="card-account-details"></b-icon>
        <span class="mobile-nav-label">Blanket VOB</span>
      </router-link>

      <router-link
        :to="{ name: 'Reimbursement' }"
        class="mobile-nav-tab"
        :class="{ 'is-active': isReimbursementActive }"
        aria-label="Reimbursement"
      >
        <b-icon icon="chart-bar"></b-icon>
        <span class="mobile-nav-label">Reimbursement</span>
      </router-link>
      <router-link
        :to="{ name: 'PatientVerificationList' }"
        class="mobile-nav-tab"
        :class="{ 'is-active': isPatientVerificationActive }"
        aria-label="Patient Verifier"
      >
        <b-icon icon="account-check"></b-icon>
        <span class="mobile-nav-label">Patient Verifier</span>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Nav',
  computed: {
    ...mapGetters(['isLoggedIn', 'isAdmin', 'isManager', 'permBatchInquiry', 'user']),
    isPatientVerificationActive() {
      return this.$route.path.startsWith('/patient-verifications');
    },
    isInquiriesActive() {
      return this.$route.path.includes('inquiries');
    },
    isBlanketVOBActive() {
      return this.$route.path.includes('blanket-vob-search');
    },
    isReimbursementActive() {
      return this.$route.path.includes('reimbursement');
    },
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
    },
  },
};
</script>

<style scoped>
hr {
  margin: 0.5rem 0;
}

.nav-wrapper {
  position: sticky;
  top: 0;
  z-index: 1000;
}

.nav-item {
  padding: 0 !important;
  margin: 0 !important;
  height: 100% !important;
}

.nav-link {
  display: flex;
  align-items: center;
  padding: 0 0.75rem;
  color: #4a4a4a;
  text-decoration: none;
  height: 100%;
  margin: 0;
}

.nav-link.is-active {
  color: #7957d5 !important;
  background-color: hsl(0, 0%, 97%) !important;
}

:deep(.b-navbar-item) {
  padding: 0 !important;
  height: 100% !important;
  margin: 0 !important;
  display: flex !important;
  align-items: stretch !important;
}

:deep(.b-navbar-item .navbar-link) {
  padding: 0 !important;
  height: 100% !important;
  margin: 0 !important;
}

:deep(.b-navbar-item.is-active) {
  background-color: hsl(0, 0%, 97%) !important;
  color: #7957d5 !important;
}

:deep(.b-navbar-item.is-active:hover) {
  background-color: hsl(0, 0%, 97%) !important;
  color: #7957d5 !important;
}

:deep(.navbar) {
  min-height: 3.25rem !important;
}

:deep(.navbar-item) {
  min-height: 3.25rem !important;
}

/* Desktop nav items - hide on mobile/tablet */
.desktop-nav-item {
  display: flex !important;
}

@media (max-width: 1023px) {
  .desktop-nav-item {
    display: none !important;
  }
}

/* Mobile Navigation Tabs */
.mobile-nav-tabs {
  display: none;
}

@media (max-width: 1023px) {
  .mobile-nav-tabs {
    display: flex;
    justify-content: space-around;
    background: white;
    border-bottom: 1px solid #e5e7eb;
    padding: 0.5rem 0.25rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  }

  .mobile-nav-tab {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.25rem;
    padding: 0.5rem 0.75rem;
    color: #6b7280;
    text-decoration: none;
    border-radius: 0;
    transition: all 0.3s ease;
    font-weight: 600;
    font-size: 0.75rem;
    flex: 1;
    text-align: center;
  }

  .mobile-nav-tab :deep(.icon) {
    font-size: 1.25rem;
    margin: 0;
  }

  .mobile-nav-tab span {
    line-height: 1.2;
  }

  .mobile-nav-tab:hover {
    background: rgba(121, 87, 213, 0.08);
    color: #7957d5;
  }

  .mobile-nav-tab.is-active {
    background: linear-gradient(135deg, #7957d5 0%, #9b7fe8 100%);
    color: white;
  }

  .mobile-nav-tab.is-active :deep(.icon) {
    color: white;
  }
}

@media (max-width: 480px) {
  .mobile-nav-tab {
    min-width: 0;
    min-height: 44px;
    justify-content: center;
    padding: 0.5rem;
  }

  .mobile-nav-label {
    display: none;
  }
}

/* Tablet view - slightly larger tabs */
@media (min-width: 768px) and (max-width: 1023px) {
  .mobile-nav-tab {
    font-size: 0.875rem;
    padding: 0.625rem 1rem;
  }

  .mobile-nav-tab :deep(.icon) {
    font-size: 1.35rem;
  }
}

/* Style user dropdown on mobile */
@media (max-width: 1023px) {
  :deep(.navbar-end .navbar-item.has-dropdown > .navbar-link) {
    display: none !important;
  }

  :deep(.navbar-end .navbar-item.has-dropdown .navbar-dropdown) {
    box-shadow: none !important;
    border: none !important;
  }
}
</style>
